export const transaksiMasukFormData = () => {
  return [
    {
      id: "jumlah_transaksi_masuk",
      label: "Jumlah Transaksi Masuk",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Nilai Transaksi...",
        },
      ],
    },
  ];
};
